@if (saving) {
<div class="loader-overlay">
  <div class="backdrop"></div>
  <ap-loading class="loader" [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
</div>
}
<div class="top-action-bar">
  <ap-button [compact]="true" [btnType]="'primary'" [label]="'Go Back'" (onClick)="cancel()">
  </ap-button>
</div>
<div class="form-template-wrapper">
  <div class="bulk-supersede">
    <div class="title">DST Bulk Supersede Upload</div>
    <div class="statements-container ap-mt-spacing-7">
      <div class="dnd-text-info">
        Drag and drop the file disclosure data to be converted to XML into the box below. Only {{fileAcceptShort.join(',')}} files are accepted.
      </div>
      @for (s of statements; track $index) {
<div class="statement-details" [ngClass]="{'error': isValidPdf === false}"
           dragAndDropUpload [maxLength]="1" [allowedExts]="fileAcceptShort" [disabled]="!s.isEdit"
           (maxLenExceeded)="onMaxLenExceeded()" (extNotMet)="onExtNotMet()" (filesDropped)="onFilesDropped($event, s)">
        <div class="edit-box">
          <ap-button [btnType]="'secondary'" [compact]="true" (onClick)="toggle(s)">
            @if (!s.isEdit) {
<span class="Appkit4-icon a-btn-icon icon-pencil-fill"></span>
}
            @if (s.isEdit) {
<span class="Appkit4-icon a-btn-icon icon-end-process-fill"></span>
}
            {{s.isEdit ? 'Close' : 'Edit'}}
          </ap-button>
        </div>
        <table>
          <thead>
          <tr>
            <th>Statement Id</th>
            <th>Primary LEID</th>
            <th>Branch Entity</th>
            <th style="width: 30%;">File Name</th>
            <th>Provided By</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{s.STATEMENTID}}</td>
            <td>
              @if (!s.isEdit) {
<span>{{s.PRIMARYLEID}}</span>
}
              @if (s.isEdit) {
<dst-template-leid-selector [preloadLEID]="s.PRIMARYLEID" [label]="''" [labelId]="'1'"
                                          (onSelectedLEChanged)="onPrimaryEntityChanged($event, s)">
              </dst-template-leid-selector>
}
            </td>
            <td>
              @if (!s.isEdit) {
<span>{{s.BRANCHENTITY}}</span>
}
              @if (s.isEdit) {
<dst-template-leid-selector [preloadLEID]="s.BRANCHENTITY" [isBranchEntity]="true" [label]="''" [labelId]="'1'"
                                          (onSelectedLEChanged)="onBranchEntityChanged($event, s)">
              </dst-template-leid-selector>
}
            </td>
            <td>
              @if (!s.hideFileName) {
<span>{{s.FILENAME}}</span>
}
              @if (s.isEdit) {
<span class="Appkit4-icon icon-delete-fill" style="margin-left: 10px" (click)="delete(s)"></span>
}
            </td>
            <td>{{s.PROVIDEDBY}}</td>
          </tr>
          </tbody>
        </table>
      </div>
}
    </div>
  </div>
</div>
